import React, { forwardRef, useCallback, useImperativeHandle } from 'react';
import classNames from 'classnames';
import { Modal } from 'ncoded-component-library';
import {
  ModalProps,
  ModalRef,
} from 'ncoded-component-library/build/components/organisms/Modal/Modal.component';
import useCallbackRef from 'hooks/useCallbackRef';
import { useTranslation } from 'react-i18next';
import DownloadReportForm from './components/DownloadReportForm';

import './DownloadReportModal.styles.scss';

type DownloadReportModalProps = {
  className?: string;
  withExtendedSections: boolean;
} & ModalProps;

const DownloadReportModal: React.ForwardRefRenderFunction<
  ModalRef,
  DownloadReportModalProps
> = (props, ref) => {
  const { className, withExtendedSections, ...rest } = props;

  const [modal, modalRef] = useCallbackRef<ModalRef>();

  useImperativeHandle(ref, () => modal, [modal]);

  const classes = classNames('download-report-modal', className);

  const { t } = useTranslation();

  const onCancel = useCallback(() => modal?.close(), [modal]);

  return (
    <Modal
      ref={modalRef}
      className={classes}
      title={t('exportAnalytics')}
      {...rest}
    >
      <p className="description">{t('chooseInformationToIncludeExport')}</p>

      <DownloadReportForm
        withExtendedSections={withExtendedSections}
        onCancel={onCancel}
      />
    </Modal>
  );
};

export default forwardRef(DownloadReportModal);
